import React from "react";

export function DatenschutzContent() {
    return (
        <div className="prose prose-sm max-w-none prose-headings:scroll-mt-24 prose-a:text-purple-700">
            <h2 id="datenschutz">Datenschutzerklärung</h2>

            <p className="text-sm text-gray-600">
                Stand: {new Date().toLocaleDateString("de-DE")}
            </p>

            <h3>1. Verantwortlicher</h3>
            <p>
                Johannsen IT Solutions<br />
                Thorben Johannsen<br />
                Von-Weber-Str. 7<br />
                Ostrhauderfehn, Deutschland<br />
                E-Mail:{" "}
                <a href="mailto:kontakt@johannsen-its.de">kontakt@johannsen-its.de</a>
            </p>

            <h3>2. Allgemeine Hinweise</h3>
            <p>
                Wir nehmen den Schutz Ihrer personenbezogenen Daten ernst. Personenbezogene
                Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                Diese Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir
                sie nutzen.
            </p>

            <h3>3. Zugriffsdaten / Server-Logfiles</h3>
            <p>
                Beim Besuch der Website können durch den Hosting-Anbieter Zugriffsdaten
                (z.B. IP-Adresse, Datum/Uhrzeit, aufgerufene Seite, User-Agent) in
                Server-Logfiles verarbeitet werden. Die Verarbeitung erfolgt zur
                Gewährleistung von Stabilität und Sicherheit.
            </p>

            <h3>4. Kontaktaufnahme</h3>
            <p>
                Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben zur Bearbeitung
                der Anfrage verarbeitet.
            </p>

            <h3>5. Kontaktformular (Formspree)</h3>
            <p>
                Für unser Kontaktformular nutzen wir den Dienst <strong>Formspree</strong>.
                Dabei werden die von Ihnen eingegebenen Daten (z.B. Name, E-Mail, Nachricht,
                ggf. weitere Felder) zum Zweck der Bearbeitung Ihrer Anfrage verarbeitet.
            </p>
            <ul>
                <li><strong>Zweck:</strong> Bearbeitung Ihrer Anfrage, Rückmeldung, ggf. Angebotserstellung.</li>
                <li><strong>Speicherdauer:</strong> so lange wie erforderlich bzw. gesetzlich notwendig.</li>
            </ul>

            <h3>6. Ihre Rechte</h3>
            <ul>
                <li>Auskunft</li>
                <li>Berichtigung</li>
                <li>Löschung</li>
                <li>Einschränkung der Verarbeitung</li>
                <li>Datenübertragbarkeit</li>
                <li>Widerspruch</li>
            </ul>

            <h3>7. SSL-/TLS-Verschlüsselung</h3>
            <p>
                Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung, damit
                Daten nicht von Dritten mitgelesen werden können.
            </p>

            <h3>8. Änderungen</h3>
            <p>
                Wir können diese Datenschutzerklärung anpassen, wenn sich Rechtslage oder
                eingesetzte Dienste ändern.
            </p>

            <hr />
        </div>
    );
}
